export const ANIMATION_FRAME = '@@scenePlanet/ANIMATION_FRAME',
    animationFrame = (delta) => {
        return {type: ANIMATION_FRAME, delta};
    };


// WEBPACK FOOTER //
// ./src/apps/scene-planet/actions/index.js